var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import ConfirmationAndInformationPoup, { POPUP_TYPE } from '../../components/UtilityComponents/ConfirmationAndInformationPoup';
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Box, CircularProgress, Typography } from '@mui/material';
import { baseColors } from '../../Themes/colors';
import MainDetails from './MainDetails';
import RightSection from './RightSection';
import { api_service } from '../../api/api_service';
import { api_urls } from '../../api/api_urls';
import constants from '../../config/constants';
import { convertStringValuesToNumbers } from '../../utils/commonUtilities';
import { utility } from '../../utils';
import UserDefinedFields from './UserDefinedFields';
import PaymentSchedule from './PaymentSchedule';
import FinancingAdjustments from './FinancingAdjustments';
import DocumentsManagement from './DocumentsManagement';
import AccountsPayable from './AccountsPayable';
import Liens from './Liens';
import EFTAssignment from './EFTAssignments';
import CollateralAssets from './CollateralAssets';
import EquipmentAssets from './EquipmentAssets';
import InsuranceManagement from './InsuranceManagement';
import ScheduleBillables from './ScheduleBillables';
import Reports from './Reports';
import BacklogAppOverview from './BacklogAppOverview';
import BacklogPostDocsAI from './BacklogPostDocsAI';
import AiReviewLoader from './components/overview/AiReviewLoader';
import { findSourceDocuments } from './postDocsAiReview_service';
import * as XLSX from 'xlsx';
import { escapeHtml, decodeArrayBufferText, isZipContainer, cleanReadableLines, extractLegacyDocReadableText, buildEmlPreview, } from './utils/documentPreviewHelpers';
import { useDispatch, useSelector } from 'react-redux';
import ApplicationDetailsPanel from '../applicationManagement/components/ApplicationDetailsPanel';
import DocumentPreviewPanel from './DocumentPreviewPanel';
import { backlog_actions } from '../../actions/backlog_actions';
import { NavigationConfig } from '../../utils/navigation_config';
import { fetchBacklogUniqueStatusOptions } from './useBacklogApplication';
var STEP_STATUS_SEQUENCE = [
    { label: 'Credit', value: 'Credit' },
    { label: 'More Info Requested', value: 'Credit More Info' },
    { label: 'Approved', value: 'Approved' },
    { label: 'Documents', value: 'Documents' },
    { label: 'Booked', value: 'Booked' },
    { label: 'Withdrawn', value: 'Withdrawn' },
    { label: 'Declined', value: 'Declined' },
    { label: 'Cancelled', value: 'Cancelled' },
];
function normalizeStatus(value) {
    var trimmed = "".concat(value !== null && value !== void 0 ? value : '').trim();
    if (!trimmed)
        return '';
    var lower = trimmed.toLowerCase();
    if (lower.includes('docs back') || lower.includes('more info'))
        return 'Credit More Info';
    if (lower === 'credit more info' || lower === 'more info requested')
        return 'Credit More Info';
    if (lower === 'credit')
        return 'Credit';
    if (lower === 'approved')
        return 'Approved';
    if (lower === 'documents'
        || lower.includes('docs out')
        || lower.includes('passed to booking')
        || lower.includes('docs in cm review')
        || lower.includes('returned to sales support')
        || lower.includes('return to cm')
        || lower.includes('progress payment processing')
        || lower.includes('set to fund'))
        return 'Documents';
    if (lower === 'booked')
        return 'Booked';
    if (lower === 'withdrawn')
        return 'Withdrawn';
    if (lower === 'declined')
        return 'Declined';
    if (lower === 'cancelled' || lower === 'canceled')
        return 'Cancelled';
    return trimmed;
}
function buildStatusSteps(currentStatus, statusGroup) {
    var isBooked = "".concat(currentStatus !== null && currentStatus !== void 0 ? currentStatus : '').trim().toLowerCase().includes('booked');
    var resolvedGroup = isBooked ? 'Booked' : (statusGroup || normalizeStatus(currentStatus));
    var matchedIndex = STEP_STATUS_SEQUENCE.findIndex(function (step) { return step.value === resolvedGroup; });
    var lastMainFlowIndex = STEP_STATUS_SEQUENCE.findIndex(function (step) { return step.value === 'Booked'; });
    return STEP_STATUS_SEQUENCE.map(function (step, index) { return ({
        label: step.label,
        status: index === matchedIndex
            ? 'active'
            : (matchedIndex >= 0 && matchedIndex <= lastMainFlowIndex && index < matchedIndex ? 'completed' : 'pending'),
    }); });
}
var EXTENSION_MIME_MAP = {
    pdf: 'application/pdf',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    eml: 'message/rfc822',
    txt: 'text/plain',
    html: 'text/html',
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    xls: 'application/vnd.ms-excel',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
};
function getMimeTypeFromFileName(fileName) {
    var _a, _b, _c;
    if (!fileName)
        return 'application/octet-stream';
    var extension = (_b = (_a = fileName.split('.').pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : '';
    return (_c = EXTENSION_MIME_MAP[extension]) !== null && _c !== void 0 ? _c : 'application/octet-stream';
}
function getFileExtension(fileName) {
    var _a;
    return ((_a = fileName === null || fileName === void 0 ? void 0 : fileName.split('.').pop()) !== null && _a !== void 0 ? _a : '').toLowerCase();
}
function decodeBase64ToBytes(base64Value) {
    var _a;
    var decodedString = globalThis.atob(base64Value);
    var decodedBytes = new Uint8Array(decodedString.length);
    for (var index = 0; index < decodedString.length; index += 1) {
        decodedBytes[index] = (_a = decodedString.codePointAt(index)) !== null && _a !== void 0 ? _a : 0;
    }
    return decodedBytes;
}
function readBinaryPayload(responseData, mimeType, fileName) {
    if (responseData instanceof ArrayBuffer) {
        return {
            arrayBufferData: responseData,
            resolvedMimeType: mimeType,
        };
    }
    if (typeof responseData !== 'string') {
        return;
    }
    var trimmed = responseData.trim();
    if (!trimmed) {
        return;
    }
    if (trimmed.startsWith('data:')) {
        var _a = trimmed.split(',', 2), meta = _a[0], base64Payload = _a[1];
        var dataUriMimeType = meta.replace('data:', '').replace(';base64', '');
        return {
            arrayBufferData: decodeBase64ToBytes(base64Payload !== null && base64Payload !== void 0 ? base64Payload : '').buffer,
            resolvedMimeType: dataUriMimeType || mimeType,
        };
    }
    var normalizedValue = trimmed.split(/\s+/).join('');
    if (!normalizedValue || normalizedValue.length % 4 !== 0 || !/^[A-Za-z0-9+/=]+$/.test(normalizedValue)) {
        return;
    }
    return {
        arrayBufferData: decodeBase64ToBytes(normalizedValue).buffer,
        resolvedMimeType: mimeType || getMimeTypeFromFileName(fileName),
    };
}
function buildSpreadsheetPreview(arrayBufferData) {
    var workbook = XLSX.read(arrayBufferData, { type: 'array' });
    var firstWorksheetName = workbook.SheetNames[0];
    var firstWorksheet = firstWorksheetName ? workbook.Sheets[firstWorksheetName] : undefined;
    return {
        previewType: 'xlsx',
        previewHtml: firstWorksheet
            ? XLSX.utils.sheet_to_html(firstWorksheet)
            : '<p>No worksheet available for preview.</p>',
    };
}
function buildTextPreviewFromBinary(arrayBufferData, fileName, mimeType) {
    var decodedText = decodeArrayBufferText(arrayBufferData);
    var cleanLines = cleanReadableLines(decodedText).slice(0, 320);
    var previewText = cleanLines.join('\n').slice(0, 60000);
    var titleText = fileName ? "".concat(fileName, "\n") : '';
    var metaText = mimeType ? "Type: ".concat(mimeType, "\n\n") : '';
    var body = previewText || 'Preview is unavailable for this file type. Showing metadata only.';
    return {
        previewType: 'text',
        previewHtml: "<pre>".concat(escapeHtml("".concat(titleText).concat(metaText).concat(body)), "</pre>"),
    };
}
function buildLegacyDocPreview(arrayBufferData, fileName, mimeType) {
    var legacyText = extractLegacyDocReadableText(arrayBufferData);
    var titleText = fileName ? "".concat(fileName, "\n") : '';
    var metaText = mimeType ? "Type: ".concat(mimeType, "\n\n") : '';
    var body = legacyText || 'Unable to extract readable content from this legacy Word document.';
    return {
        previewType: 'text',
        previewHtml: "<pre>".concat(escapeHtml("".concat(titleText).concat(metaText).concat(body)), "</pre>"),
    };
}
var POST_DOCS_CONTRACT_STATUS = '55 - Docs Back';
var TAB_LAZY_DATA = {
    'APPLICATION_MANAGMENT:BACKLOG_QUEUE:APP_MAIN': ['meta'],
    'APPLICATION_MANAGMENT:BACKLOG_QUEUE:APP_FINANCING_ADJUSTMENTS': ['asset'],
    'APPLICATION_MANAGMENT:BACKLOG_QUEUE:APP_BILLING_PAYMENT': ['asset', 'meta'],
    'APPLICATION_MANAGMENT:BACKLOG_QUEUE:APP_EFT_ASSIGNMENT': ['meta'],
    'APPLICATION_MANAGMENT:BACKLOG_QUEUE:APP_EQUIPMENT': ['asset', 'meta'],
    'APPLICATION_MANAGMENT:BACKLOG_QUEUE:APP_SCHEDULE_BILLABLES': ['asset'],
    'APPLICATION_MANAGMENT:BACKLOG_QUEUE:APP_INSURANCE_MGMT': ['asset'],
};
var BacklogAppDetails = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5;
    var id = useParams().id;
    var location = useLocation();
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var navConfig = NavigationConfig;
    var _6 = useState(0), selectedTab = _6[0], setSelectedTab = _6[1];
    var _7 = useState(), appResp = _7[0], setAppResp = _7[1];
    var _8 = useState(), mainResp = _8[0], setMainResp = _8[1];
    var _9 = useState([]), statusGroupOptions = _9[0], setStatusGroupOptions = _9[1];
    useEffect(function () {
        fetchBacklogUniqueStatusOptions().then(setStatusGroupOptions);
    }, []);
    var _10 = useState(), assetResp = _10[0], setAssetResp = _10[1];
    var _11 = useState(), appMetaData = _11[0], setappMetaData = _11[1];
    var _12 = useState({ asset: 'idle', meta: 'idle' }), lazyStatus = _12[0], setLazyStatus = _12[1];
    var lazyStatusRef = useRef({ asset: 'idle', meta: 'idle' });
    var setLazyDatasetStatus = function (dataset, status) {
        var _a;
        lazyStatusRef.current = __assign(__assign({}, lazyStatusRef.current), (_a = {}, _a[dataset] = status, _a));
        setLazyStatus(lazyStatusRef.current);
    };
    var isDetailsCollapsed = false;
    var _13 = useState([]), appDocuments = _13[0], setAppDocuments = _13[1];
    var _14 = useState(true), isAppDocumentsLoading = _14[0], setIsAppDocumentsLoading = _14[1];
    var _15 = useState(true), isMainInfoLoading = _15[0], setIsMainInfoLoading = _15[1];
    var _16 = useState(undefined), mainInfoLoadedForId = _16[0], setMainInfoLoadedForId = _16[1];
    var latestIdRef = useRef(id);
    latestIdRef.current = id;
    var mainInfoRequestSeqRef = useRef(0);
    var userBasicInfo = useSelector(function (store) { return store.User; });
    var roleType = (_a = userBasicInfo === null || userBasicInfo === void 0 ? void 0 : userBasicInfo.userData) === null || _a === void 0 ? void 0 : _a.RoleType;
    var isConsumerProgram = String((_c = (_b = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _b === void 0 ? void 0 : _b.FinanceProgramDescription) !== null && _c !== void 0 ? _c : '').toLowerCase().includes('consumer');
    var contractStatusHistory = (_d = mainResp === null || mainResp === void 0 ? void 0 : mainResp.History) === null || _d === void 0 ? void 0 : _d.ContractStatusHistory;
    var isPostDocsStage = Array.isArray(contractStatusHistory)
        && contractStatusHistory.some(function (entry) { var _a; return String((_a = entry === null || entry === void 0 ? void 0 : entry.ContractStatus) !== null && _a !== void 0 ? _a : '').trim() === POST_DOCS_CONTRACT_STATUS; });
    var awaitsPostDocsCheck = isConsumerProgram && isPostDocsStage;
    var isCurrentlyDocsBack = String((_f = (_e = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _e === void 0 ? void 0 : _e.ContractStatus) !== null && _f !== void 0 ? _f : '').trim().startsWith(POST_DOCS_CONTRACT_STATUS);
    var showPostDocsReview = awaitsPostDocsCheck && Boolean(findSourceDocuments(appDocuments).documentPackage);
    var overviewWillShow = !isMainInfoLoading && mainInfoLoadedForId === id && (!awaitsPostDocsCheck || (!isAppDocumentsLoading && !showPostDocsReview));
    var _17 = useState([]), creditReportItems = _17[0], setCreditReportItems = _17[1];
    var _18 = useState(null), aiReviewData = _18[0], setAiReviewData = _18[1];
    var _19 = useState(true), isAiReviewLoading = _19[0], setIsAiReviewLoading = _19[1];
    var _20 = useState(false), isRightPanelCompact = _20[0], setIsRightPanelCompact = _20[1];
    var pageRootRef = useRef(null);
    var _21 = useState(45), pageTopOffset = _21[0], setPageTopOffset = _21[1];
    useLayoutEffect(function () {
        var _a;
        var measure = function () {
            var _a;
            var top = (_a = pageRootRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().top;
            if (top !== undefined) {
                setPageTopOffset(Math.max(0, Math.floor(top + window.scrollY)));
            }
        };
        measure();
        window.addEventListener('resize', measure);
        var headerEl = (_a = pageRootRef.current) === null || _a === void 0 ? void 0 : _a.previousElementSibling;
        var observer = headerEl && typeof ResizeObserver !== 'undefined' ? new ResizeObserver(measure) : null;
        if (headerEl && observer)
            observer.observe(headerEl);
        return function () {
            window.removeEventListener('resize', measure);
            observer === null || observer === void 0 ? void 0 : observer.disconnect();
        };
    }, []);
    var _22 = useState(null), selectedDocumentPreview = _22[0], setSelectedDocumentPreview = _22[1];
    var rolePermissions = ((_g = userBasicInfo === null || userBasicInfo === void 0 ? void 0 : userBasicInfo.userData) === null || _g === void 0 ? void 0 : _g.RolePermissions) || [];
    var isLoan = ((_h = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _h === void 0 ? void 0 : _h.IsLoan) === true;
    var headerChips = [
        { label: 'Finance Product', value: (_j = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _j === void 0 ? void 0 : _j.FinanceProduct },
        { label: 'Program', value: (_k = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _k === void 0 ? void 0 : _k.FinanceProgramDescription },
        { label: 'Credit Status', value: (_o = (_m = (_l = appResp === null || appResp === void 0 ? void 0 : appResp.CreditDecisions) === null || _l === void 0 ? void 0 : _l.find(function (item) { var _a; return item.CreditDecisionOId == ((_a = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _a === void 0 ? void 0 : _a.CreditDecisionOId); })) === null || _m === void 0 ? void 0 : _m.Decision) !== null && _o !== void 0 ? _o : '--' },
        { label: 'Status', value: (_q = (_p = appResp === null || appResp === void 0 ? void 0 : appResp.ContractStatusList) === null || _p === void 0 ? void 0 : _p.find(function (item) { var _a; return item.OId == ((_a = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _a === void 0 ? void 0 : _a.StatusOId); })) === null || _q === void 0 ? void 0 : _q.Status },
    ].filter(function (chip) { return chip.label === 'Credit Status' || (chip.value !== undefined && chip.value !== null && String(chip.value).trim() !== ''); });
    var primaryCustomer = (_s = (_r = mainResp === null || mainResp === void 0 ? void 0 : mainResp.RelatedAccounts) === null || _r === void 0 ? void 0 : _r.CustomerInfo) === null || _s === void 0 ? void 0 : _s.find(function (customer) { return customer.IsPrimary === 1; });
    var navigationState = ((_t = location.state) !== null && _t !== void 0 ? _t : {});
    var navigationStatus = (_u = navigationState.status) !== null && _u !== void 0 ? _u : null;
    var navigationActiveTab = navigationState.activeTab === 1 ? 1 : 0;
    var buildPreviewPayload = function (response, fileName) { return __awaiter(void 0, void 0, void 0, function () {
        var rawContentType, normalizedContentType, textDecoder, jsonString, jsonData, mimeType, binaryPayload, arrayBufferData, extension, isDocxType, isXlsxType, isDocType, isEmlType, isTextType, isImageType, isPdfType, zipContainer, binaryBlob, objectUrl;
        var _a, _b;
        return __generator(this, function (_c) {
            rawContentType = ((_a = response === null || response === void 0 ? void 0 : response.contentType) !== null && _a !== void 0 ? _a : '').toLowerCase();
            normalizedContentType = rawContentType.split(';')[0] || '';
            if (normalizedContentType.includes('application/json')) {
                textDecoder = new TextDecoder('utf-8');
                jsonString = textDecoder.decode(response.data);
                jsonData = JSON.parse(jsonString);
                utility.alert((jsonData === null || jsonData === void 0 ? void 0 : jsonData.message) || 'Unable to open document.', constants.TOAST_TYPES.ERROR);
                return [2];
            }
            mimeType = normalizedContentType && normalizedContentType !== 'application/octet-stream'
                ? normalizedContentType
                : getMimeTypeFromFileName(fileName);
            binaryPayload = readBinaryPayload(response.data, mimeType, fileName);
            arrayBufferData = binaryPayload === null || binaryPayload === void 0 ? void 0 : binaryPayload.arrayBufferData;
            mimeType = (_b = binaryPayload === null || binaryPayload === void 0 ? void 0 : binaryPayload.resolvedMimeType) !== null && _b !== void 0 ? _b : mimeType;
            extension = getFileExtension(fileName);
            if (!arrayBufferData) {
                utility.alert('Unable to process document response.', constants.TOAST_TYPES.ERROR);
                return [2];
            }
            isDocxType = mimeType.includes('application/vnd.openxmlformats-officedocument.wordprocessingml.document');
            isXlsxType = mimeType.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
                || mimeType.includes('application/vnd.ms-excel');
            isDocType = mimeType.includes('application/msword') || mimeType.includes('application/vnd.ms-word');
            isEmlType = mimeType.includes('message/rfc822') || mimeType.includes('application/vnd.ms-outlook');
            isTextType = mimeType.startsWith('text/');
            isImageType = mimeType.startsWith('image/');
            isPdfType = mimeType.includes('application/pdf');
            zipContainer = isZipContainer(arrayBufferData);
            if (isDocxType || (extension === 'docx') || (isDocType && zipContainer)) {
                return [2, {
                        previewType: 'docx',
                        binaryData: arrayBufferData,
                        previewHtml: undefined,
                    }];
            }
            if (isXlsxType) {
                try {
                    return [2, buildSpreadsheetPreview(arrayBufferData)];
                }
                catch (error) {
                    console.error('Unable to preview XLSX file.', error);
                    utility.alert('Unable to preview XLSX file.', constants.TOAST_TYPES.ERROR);
                    return [2];
                }
            }
            if (isEmlType || extension === 'eml') {
                return [2, buildEmlPreview(arrayBufferData, fileName)];
            }
            if (isDocType) {
                return [2, buildLegacyDocPreview(arrayBufferData, fileName, mimeType)];
            }
            if (isTextType) {
                return [2, buildTextPreviewFromBinary(arrayBufferData, fileName, mimeType)];
            }
            if (!isImageType && !isPdfType) {
                return [2, buildTextPreviewFromBinary(arrayBufferData, fileName, mimeType)];
            }
            binaryBlob = new Blob([arrayBufferData], { type: mimeType });
            objectUrl = URL.createObjectURL(binaryBlob);
            return [2, {
                    url: objectUrl,
                    previewType: isImageType ? 'image' : 'pdf',
                }];
        });
    }); };
    var fetchDocumentPreview = function (documentIdentifier, fileName, cancelToken) { return __awaiter(void 0, void 0, void 0, function () {
        var response, contentType;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4, api_service.get({
                        endPoint: api_urls.GET_APP_DOCUMENTS,
                        payLoad: {
                            TxAspireOId: id,
                            DocumentIdentifier: documentIdentifier,
                        },
                        showLoader: false,
                        responseType: 'arraybuffer',
                        cancelToken: cancelToken,
                    })];
                case 1:
                    response = _b.sent();
                    contentType = (_a = response === null || response === void 0 ? void 0 : response.headers) === null || _a === void 0 ? void 0 : _a['content-type'];
                    return [2, buildPreviewPayload(__assign(__assign({}, response), { contentType: contentType }), fileName)];
            }
        });
    }); };
    var previewRequestIdRef = useRef(0);
    var previewCancelSourceRef = useRef(null);
    var startPreviewRequest = function () {
        var _a;
        (_a = previewCancelSourceRef.current) === null || _a === void 0 ? void 0 : _a.cancel();
        var source = api_service.cancelToken();
        previewCancelSourceRef.current = source;
        previewRequestIdRef.current += 1;
        return { requestId: previewRequestIdRef.current, cancelToken: source.token };
    };
    var isPreviewRequestCurrent = function (requestId) { return previewRequestIdRef.current === requestId; };
    var releasePreviewPayload = function (payload) {
        var _a;
        if ((_a = payload === null || payload === void 0 ? void 0 : payload.url) === null || _a === void 0 ? void 0 : _a.startsWith('blob:')) {
            URL.revokeObjectURL(payload.url);
        }
    };
    useEffect(function () { return function () {
        var _a;
        previewRequestIdRef.current += 1;
        (_a = previewCancelSourceRef.current) === null || _a === void 0 ? void 0 : _a.cancel();
        previewCancelSourceRef.current = null;
    }; }, [id]);
    var handleDocumentPreviewClose = function () {
        var _a;
        previewRequestIdRef.current += 1;
        (_a = previewCancelSourceRef.current) === null || _a === void 0 ? void 0 : _a.cancel();
        previewCancelSourceRef.current = null;
        setSelectedDocumentPreview(null);
    };
    var handleDocumentOpen = function (document) { return __awaiter(void 0, void 0, void 0, function () {
        var documentIdentifier, fileName, title, _a, requestId, cancelToken, previewPayload, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    documentIdentifier = document === null || document === void 0 ? void 0 : document.DocumentIdentifier;
                    fileName = (document === null || document === void 0 ? void 0 : document.FileName) || (document === null || document === void 0 ? void 0 : document.DocumentName);
                    title = (document === null || document === void 0 ? void 0 : document.DocumentName) || (document === null || document === void 0 ? void 0 : document.FileName) || 'Document Preview';
                    if (!documentIdentifier) {
                        utility.alert('Document is not available for preview.', constants.TOAST_TYPES.ERROR);
                        return [2];
                    }
                    _a = startPreviewRequest(), requestId = _a.requestId, cancelToken = _a.cancelToken;
                    setSelectedDocumentPreview({
                        documentIdentifier: documentIdentifier,
                        title: title,
                        loading: true,
                        source: 'documents',
                    });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4, fetchDocumentPreview(documentIdentifier, fileName, cancelToken)];
                case 2:
                    previewPayload = _b.sent();
                    if (!isPreviewRequestCurrent(requestId)) {
                        releasePreviewPayload(previewPayload);
                        return [2];
                    }
                    if (!previewPayload) {
                        setSelectedDocumentPreview(null);
                        return [2];
                    }
                    setSelectedDocumentPreview({
                        documentIdentifier: documentIdentifier,
                        title: title,
                        loading: false,
                        source: 'documents',
                        fileUrl: previewPayload.url,
                        previewType: previewPayload.previewType,
                        previewHtml: previewPayload.previewHtml,
                        binaryData: previewPayload.binaryData,
                        jsonData: previewPayload.jsonData,
                        attachments: previewPayload.attachments,
                    });
                    return [3, 4];
                case 3:
                    error_1 = _b.sent();
                    if (!isPreviewRequestCurrent(requestId))
                        return [2];
                    utility.alert(error_1, constants.TOAST_TYPES.ERROR);
                    setSelectedDocumentPreview(null);
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); };
    var fetchCreditReportPdf = function (creditReportOId, DocumentIdentifier, cancelToken) { return __awaiter(void 0, void 0, void 0, function () {
        var response, contentType;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4, api_service.get({
                        endPoint: api_urls.GET_APP_DOCUMENTS,
                        payLoad: {
                            TxAspireOId: id,
                            DocumentIdentifier: DocumentIdentifier,
                        },
                        showLoader: false,
                        responseType: 'arraybuffer',
                        cancelToken: cancelToken,
                    })];
                case 1:
                    response = _b.sent();
                    contentType = (_a = response === null || response === void 0 ? void 0 : response.headers) === null || _a === void 0 ? void 0 : _a['content-type'];
                    return [2, buildPreviewPayload(__assign(__assign({}, response), { contentType: contentType }), DocumentIdentifier)];
            }
        });
    }); };
    var handleCreditReportOpen = function (report) { return __awaiter(void 0, void 0, void 0, function () {
        var creditReportOId, reportName, fileName, _a, requestId, cancelToken, previewPayload, pdfError_1, reportJson, jsonResponse, jsonError_1, rawHtml, processedHtml, error_2;
        var _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return __generator(this, function (_l) {
            switch (_l.label) {
                case 0:
                    creditReportOId = report === null || report === void 0 ? void 0 : report.CreditReportOId;
                    reportName = (report === null || report === void 0 ? void 0 : report.ReportName) || (report === null || report === void 0 ? void 0 : report.CreditBureau) || 'Credit Report';
                    fileName = report === null || report === void 0 ? void 0 : report.FileName;
                    console.log(report, "report");
                    if (!creditReportOId) {
                        utility.alert('Credit report is not available for preview.', constants.TOAST_TYPES.ERROR);
                        return [2];
                    }
                    _a = startPreviewRequest(), requestId = _a.requestId, cancelToken = _a.cancelToken;
                    setSelectedDocumentPreview({
                        documentIdentifier: "report-".concat(String(creditReportOId)),
                        title: "".concat(reportName, " Report"),
                        loading: true,
                        source: 'reports',
                    });
                    _l.label = 1;
                case 1:
                    _l.trys.push([1, 12, , 13]);
                    if (!((report === null || report === void 0 ? void 0 : report.BureauCode) === "MidDesk")) return [3, 6];
                    _l.label = 2;
                case 2:
                    _l.trys.push([2, 4, , 5]);
                    return [4, fetchCreditReportPdf(creditReportOId, report === null || report === void 0 ? void 0 : report.DocumentIdentifier, cancelToken)];
                case 3:
                    previewPayload = _l.sent();
                    if (!isPreviewRequestCurrent(requestId)) {
                        releasePreviewPayload(previewPayload);
                        return [2];
                    }
                    if (previewPayload) {
                        setSelectedDocumentPreview({
                            documentIdentifier: "report-".concat(String(creditReportOId)),
                            title: "".concat(reportName, " Report"),
                            loading: false,
                            source: 'reports',
                            fileUrl: previewPayload.url,
                            previewType: previewPayload.previewType,
                            previewHtml: previewPayload.previewHtml,
                            binaryData: previewPayload.binaryData,
                        });
                        return [2];
                    }
                    return [3, 5];
                case 4:
                    pdfError_1 = _l.sent();
                    if (!isPreviewRequestCurrent(requestId))
                        return [2];
                    console.log('PDF fetch failed, showing empty JSON view', pdfError_1);
                    return [3, 5];
                case 5:
                    if (isPreviewRequestCurrent(requestId)) {
                        utility.alert('Unable to load the credit report.', constants.TOAST_TYPES.ERROR);
                        setSelectedDocumentPreview(null);
                    }
                    return [3, 11];
                case 6:
                    reportJson = {};
                    _l.label = 7;
                case 7:
                    _l.trys.push([7, 9, , 10]);
                    return [4, api_service.get({
                            endPoint: api_urls.BACKLOG_APPLICATION_CREDIT_REPORTS,
                            payLoad: {
                                TxAspireOId: id,
                                View: 'JSON',
                                CreditReportOId: creditReportOId,
                            },
                            showLoader: false,
                            cancelToken: cancelToken,
                        })];
                case 8:
                    jsonResponse = _l.sent();
                    reportJson = (_c = (_b = jsonResponse === null || jsonResponse === void 0 ? void 0 : jsonResponse.data) === null || _b === void 0 ? void 0 : _b.data) !== null && _c !== void 0 ? _c : {};
                    return [3, 10];
                case 9:
                    jsonError_1 = _l.sent();
                    console.log('JSON fetch failed', jsonError_1);
                    reportJson = {};
                    return [3, 10];
                case 10:
                    if (!isPreviewRequestCurrent(requestId))
                        return [2];
                    rawHtml = ((_g = (_f = (_e = (_d = reportJson === null || reportJson === void 0 ? void 0 : reportJson.XmlReport) === null || _d === void 0 ? void 0 : _d.XML_INTERFACE) === null || _e === void 0 ? void 0 : _e.CREDITREPORT) === null || _f === void 0 ? void 0 : _f.HTMLREPORT) === null || _g === void 0 ? void 0 : _g.MESSAGE) ||
                        ((_k = (_j = (_h = reportJson === null || reportJson === void 0 ? void 0 : reportJson.XML_INTERFACE) === null || _h === void 0 ? void 0 : _h.CREDITREPORT) === null || _j === void 0 ? void 0 : _j.HTMLREPORT) === null || _k === void 0 ? void 0 : _k.MESSAGE) ||
                        (reportJson === null || reportJson === void 0 ? void 0 : reportJson.HtmlContent) ||
                        null;
                    processedHtml = rawHtml
                        ? rawHtml.replace(/\\n/g, '\n').replace(/\\"/g, '"')
                        : null;
                    setSelectedDocumentPreview({
                        documentIdentifier: "report-".concat(String(creditReportOId)),
                        title: "".concat(reportName, " Report"),
                        loading: false,
                        source: 'reports',
                        previewType: 'html',
                        previewHtml: processedHtml !== null && processedHtml !== void 0 ? processedHtml : undefined,
                    });
                    _l.label = 11;
                case 11: return [3, 13];
                case 12:
                    error_2 = _l.sent();
                    if (!isPreviewRequestCurrent(requestId))
                        return [2];
                    utility.alert(error_2, constants.TOAST_TYPES.ERROR);
                    setSelectedDocumentPreview(null);
                    return [3, 13];
                case 13: return [2];
            }
        });
    }); };
    var getCreditReports = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, reportList, normalizedReports, _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4, api_service.get({
                            endPoint: api_urls.BACKLOG_APPLICATION_CREDIT_REPORTS,
                            payLoad: {
                                TxAspireOId: id,
                            },
                            showLoader: false,
                        })];
                case 1:
                    response = _c.sent();
                    reportList = Array.isArray((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.data) ? response.data.data : [];
                    normalizedReports = reportList.map(function (report, index) {
                        var _a, _b, _c, _d, _e, _f;
                        return (__assign(__assign({}, report), { CreditReportOId: (_c = (_b = (_a = report === null || report === void 0 ? void 0 : report.CreditReportOId) !== null && _a !== void 0 ? _a : report === null || report === void 0 ? void 0 : report.ReportName) !== null && _b !== void 0 ? _b : report === null || report === void 0 ? void 0 : report.BureauCode) !== null && _c !== void 0 ? _c : "report-".concat(index), ReportName: (_f = (_e = (_d = report === null || report === void 0 ? void 0 : report.ReportName) !== null && _d !== void 0 ? _d : report === null || report === void 0 ? void 0 : report.CreditBureau) !== null && _e !== void 0 ? _e : report === null || report === void 0 ? void 0 : report.BureauCode) !== null && _f !== void 0 ? _f : "Report ".concat(index + 1) }));
                    });
                    setCreditReportItems(normalizedReports);
                    return [3, 3];
                case 2:
                    _a = _c.sent();
                    setCreditReportItems([]);
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    var getApplicationAiReview = function () { return __awaiter(void 0, void 0, void 0, function () {
        var requestedId, response, error_3;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    requestedId = id;
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, 4, 5]);
                    return [4, api_service.get({
                            endPoint: api_urls.BACKLOG_APPLICATION_AI_REVIEW,
                            payLoad: {
                                TxAspireOId: id,
                            },
                            showLoader: false,
                        })];
                case 2:
                    response = _e.sent();
                    if (latestIdRef.current !== requestedId)
                        return [2];
                    if (((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.statusCode) === 200) {
                        setAiReviewData((_c = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.data) !== null && _c !== void 0 ? _c : null);
                    }
                    else {
                        setAiReviewData(null);
                        utility.alert((_d = response === null || response === void 0 ? void 0 : response.data) === null || _d === void 0 ? void 0 : _d.message, constants.TOAST_TYPES.ERROR);
                    }
                    return [3, 5];
                case 3:
                    error_3 = _e.sent();
                    if (latestIdRef.current !== requestedId)
                        return [2];
                    setAiReviewData(null);
                    utility.alert(error_3, constants.TOAST_TYPES.ERROR);
                    console.log('Error:', error_3);
                    return [3, 5];
                case 4:
                    if (latestIdRef.current === requestedId)
                        setIsAiReviewLoading(false);
                    return [7];
                case 5: return [2];
            }
        });
    }); };
    var updateContractStatus = function (contractStatus, statusReason) { return __awaiter(void 0, void 0, void 0, function () {
        var contractData, statusOId, res, error_4;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return __generator(this, function (_l) {
            switch (_l.label) {
                case 0:
                    if (!id)
                        return [2, false];
                    contractData = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData;
                    statusOId = (_b = (_a = appResp === null || appResp === void 0 ? void 0 : appResp.ContractStatusList) === null || _a === void 0 ? void 0 : _a.find(function (item) { return item.Status === contractStatus; })) === null || _b === void 0 ? void 0 : _b.OId;
                    if (!statusOId) {
                        utility.alert("Unable to find the status \"".concat(contractStatus, "\"."), constants.TOAST_TYPES.ERROR);
                        return [2, false];
                    }
                    _l.label = 1;
                case 1:
                    _l.trys.push([1, 5, , 6]);
                    return [4, api_service.put({
                            endPoint: api_urls.UPDATE_BACKLOG_CONTRACT,
                            payLoad: __assign(__assign(__assign(__assign({ StatusOId: statusOId, ContractStatus: contractStatus }, (statusReason ? { StatusReason: statusReason } : {})), { IsLoan: isLoan ? 1 : 0, TxAspireOId: contractData === null || contractData === void 0 ? void 0 : contractData.TxAspireOId, ContractAspireId: contractData === null || contractData === void 0 ? void 0 : contractData.ContractAspireId, CustomerAspireOId: (_e = (_d = (_c = mainResp === null || mainResp === void 0 ? void 0 : mainResp.RelatedAccounts) === null || _c === void 0 ? void 0 : _c.CustomerInfo) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.CustomerAspireOId, FinanceCompanyAspireId: contractData === null || contractData === void 0 ? void 0 : contractData.FinanceCompanyAspireId, ApplicationType: contractData === null || contractData === void 0 ? void 0 : contractData.ContractCategory }), ((contractData === null || contractData === void 0 ? void 0 : contractData.ContractCategory) === 'SCH' && { LOCAspireOId: contractData === null || contractData === void 0 ? void 0 : contractData.LOCAspireOId })), { Term: convertStringValuesToNumbers(contractData === null || contractData === void 0 ? void 0 : contractData.Term) }),
                            showLoader: true,
                        })];
                case 2:
                    res = _l.sent();
                    if (!(((_f = res === null || res === void 0 ? void 0 : res.data) === null || _f === void 0 ? void 0 : _f.statusCode) === 200)) return [3, 4];
                    utility.alert(((_g = res === null || res === void 0 ? void 0 : res.data) === null || _g === void 0 ? void 0 : _g.message) || 'Contract updated successfully.', constants.TOAST_TYPES.INFO);
                    return [4, refreshAllData()];
                case 3:
                    _l.sent();
                    return [2, true];
                case 4:
                    utility.alert(((_h = res === null || res === void 0 ? void 0 : res.data) === null || _h === void 0 ? void 0 : _h.message) || 'Unable to update this contract.', constants.TOAST_TYPES.ERROR);
                    return [2, false];
                case 5:
                    error_4 = _l.sent();
                    utility.alert(((_k = (_j = error_4 === null || error_4 === void 0 ? void 0 : error_4.response) === null || _j === void 0 ? void 0 : _j.data) === null || _k === void 0 ? void 0 : _k.message) || (error_4 === null || error_4 === void 0 ? void 0 : error_4.message) || 'Unable to update this contract.', constants.TOAST_TYPES.ERROR);
                    return [2, false];
                case 6: return [2];
            }
        });
    }); };
    var refreshAllData = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!id) return [3, 2];
                    return [4, Promise.all([
                            getApplicationCreditDetails(),
                            getApplicationMainDetails(),
                            lazyStatusRef.current.meta === 'done' ? getAppMetaDataDetails() : Promise.resolve(),
                            lazyStatusRef.current.asset === 'done' ? getAssetMngmtDetails() : Promise.resolve(),
                            getAppDocuments(),
                            getCreditReports(),
                            overviewWillShow ? getApplicationAiReview() : Promise.resolve(),
                        ])];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2];
            }
        });
    }); };
    var getApplicationCreditDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload, res, resp, error_5;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    payload = {
                        TxAspireOId: id
                    };
                    return [4, api_service.get({
                            endPoint: api_urls.GET_APP_CREDIT_DETAILS,
                            payLoad: payload,
                            showLoader: true
                        })];
                case 1:
                    res = _c.sent();
                    if (res.data && res.data.statusCode === 200) {
                        resp = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.data;
                        setAppResp(resp || {});
                        dispatch(backlog_actions.updateFilterState({ reduxAppResp: resp }));
                    }
                    else {
                        utility.alert((_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.message, constants.TOAST_TYPES.ERROR);
                    }
                    return [3, 3];
                case 2:
                    error_5 = _c.sent();
                    utility.alert(error_5, constants.TOAST_TYPES.ERROR);
                    console.log('Error:', error_5);
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    var getApplicationMainDetails = function (silent) {
        if (silent === void 0) { silent = false; }
        return __awaiter(void 0, void 0, void 0, function () {
            var requestedId, requestSeq, isStale, payload, res, resp, error_6;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        requestedId = id;
                        requestSeq = ++mainInfoRequestSeqRef.current;
                        isStale = function () { return requestSeq !== mainInfoRequestSeqRef.current || latestIdRef.current !== requestedId; };
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, 4, 5]);
                        payload = {
                            TxAspireOId: id
                        };
                        return [4, api_service.get({
                                endPoint: api_urls.GET_APP_MAIN_INFO,
                                payLoad: payload,
                                showLoader: !silent
                            })];
                    case 2:
                        res = _d.sent();
                        if (isStale())
                            return [2];
                        if (res.data && res.data.statusCode === 200) {
                            resp = ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.data.UDFsData.ForecastDate) ? __assign(__assign({}, res.data.data), { UDFsData: __assign(__assign({}, res.data.data.UDFsData), { ForecastDate: res.data.data.UDFsData.ForecastDate.split(' ')[0] }) }) : (_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.data;
                            setMainResp(resp || {});
                            dispatch(backlog_actions.updateFilterState({ reduxMainResp: resp }));
                        }
                        else {
                            utility.alert((_c = res === null || res === void 0 ? void 0 : res.data) === null || _c === void 0 ? void 0 : _c.message, constants.TOAST_TYPES.ERROR);
                        }
                        return [3, 5];
                    case 3:
                        error_6 = _d.sent();
                        if (isStale())
                            return [2];
                        utility.alert(error_6, constants.TOAST_TYPES.ERROR);
                        console.log('Error:', error_6);
                        return [3, 5];
                    case 4:
                        if (!isStale()) {
                            setIsMainInfoLoading(false);
                            setMainInfoLoadedForId(requestedId);
                        }
                        return [7];
                    case 5: return [2];
                }
            });
        });
    };
    var getAssetMngmtDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        var requestedId, payload, res, resp, error_7;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    requestedId = id;
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    payload = {
                        TxAspireOId: id
                    };
                    return [4, api_service.get({
                            endPoint: api_urls.GET_APP_ASSET_MNGMT_DETAILS,
                            payLoad: payload,
                            showLoader: false
                        })];
                case 2:
                    res = _c.sent();
                    if (latestIdRef.current !== requestedId)
                        return [2, null];
                    if (res.data && res.data.statusCode === 200) {
                        resp = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.data;
                        setAssetResp(resp);
                        return [2, resp];
                    }
                    else {
                        utility.alert((_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.message, constants.TOAST_TYPES.ERROR);
                    }
                    return [3, 5];
                case 3:
                    error_7 = _c.sent();
                    utility.alert(error_7, constants.TOAST_TYPES.ERROR);
                    console.log('Error:', error_7);
                    return [3, 5];
                case 4:
                    if (latestIdRef.current === requestedId)
                        setLazyDatasetStatus('asset', 'done');
                    return [7];
                case 5: return [2, null];
            }
        });
    }); };
    var getAppMetaDataDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        var requestedId, res, resp, error_8;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    requestedId = id;
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    return [4, api_service.get({
                            endPoint: api_urls.GET_APP_METADATA_DETAILS,
                            showLoader: false
                        })];
                case 2:
                    res = _c.sent();
                    if (latestIdRef.current !== requestedId)
                        return [2];
                    if (res.data && res.data.statusCode === 200) {
                        resp = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.data;
                        setappMetaData(resp);
                    }
                    else {
                        utility.alert((_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.message, constants.TOAST_TYPES.ERROR);
                    }
                    return [3, 5];
                case 3:
                    error_8 = _c.sent();
                    utility.alert(error_8, constants.TOAST_TYPES.ERROR);
                    console.log('Error:', error_8);
                    return [3, 5];
                case 4:
                    if (latestIdRef.current === requestedId)
                        setLazyDatasetStatus('meta', 'done');
                    return [7];
                case 5: return [2];
            }
        });
    }); };
    var ensureLazyDataset = function (dataset) {
        if (!id || lazyStatusRef.current[dataset] !== 'idle')
            return;
        setLazyDatasetStatus(dataset, 'loading');
        if (dataset === 'asset')
            getAssetMngmtDetails();
        else
            getAppMetaDataDetails();
    };
    var getAppDocuments = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload, res, resp, error_9;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, 3, 4]);
                    payload = {
                        TxAspireOId: id
                    };
                    return [4, api_service.get({
                            endPoint: api_urls.GET_APP_DOCUMENTS,
                            payLoad: payload,
                            showLoader: false
                        })];
                case 1:
                    res = _c.sent();
                    if (res.data && res.data.statusCode === 200) {
                        resp = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.data;
                        setAppDocuments(resp || []);
                        return [2, resp || []];
                    }
                    utility.alert((_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.message, constants.TOAST_TYPES.ERROR);
                    return [2, null];
                case 2:
                    error_9 = _c.sent();
                    utility.alert(error_9, constants.TOAST_TYPES.ERROR);
                    console.log('Error:', error_9);
                    return [2, null];
                case 3:
                    setIsAppDocumentsLoading(false);
                    return [7];
                case 4: return [2];
            }
        });
    }); };
    useEffect(function () {
        if (id) {
            setIsAppDocumentsLoading(true);
            setIsMainInfoLoading(true);
            getApplicationCreditDetails();
            getApplicationMainDetails();
            getAppDocuments();
            getCreditReports();
            setAiReviewData(null);
            setIsAiReviewLoading(true);
            setAssetResp(undefined);
            setappMetaData(undefined);
            lazyStatusRef.current = { asset: 'idle', meta: 'idle' };
            setLazyStatus(lazyStatusRef.current);
        }
    }, [id]);
    useEffect(function () {
        if (id && overviewWillShow) {
            getApplicationAiReview();
        }
    }, [id, overviewWillShow]);
    useEffect(function () {
        return function () {
            var _a;
            if ((_a = selectedDocumentPreview === null || selectedDocumentPreview === void 0 ? void 0 : selectedDocumentPreview.fileUrl) === null || _a === void 0 ? void 0 : _a.startsWith('blob:')) {
                URL.revokeObjectURL(selectedDocumentPreview.fileUrl);
            }
        };
    }, [selectedDocumentPreview === null || selectedDocumentPreview === void 0 ? void 0 : selectedDocumentPreview.fileUrl]);
    var _23 = useState(false), isAccordionEditing = _23[0], setIsAccordionEditing = _23[1];
    var _24 = useState(null), pendingNavigation = _24[0], setPendingNavigation = _24[1];
    var _25 = useState(false), showNavDialog = _25[0], setShowNavDialog = _25[1];
    var handleTabChange = function (index) {
        if (isAccordionEditing) {
            setPendingNavigation(function () { return function () { return setSelectedTab(index); }; });
            setShowNavDialog(true);
        }
        else {
            setSelectedTab(index);
        }
    };
    var goBackTarget = function () {
        var returnTo = navigationState.returnTo;
        if (returnTo === null || returnTo === void 0 ? void 0 : returnTo.path)
            navigate(returnTo.path, { state: { queueType: returnTo.queueType } });
        else
            navigate(navConfig.BacklogManagement, { state: { activeTab: navigationActiveTab } });
    };
    var handleGoBack = function () {
        if (isAccordionEditing) {
            setPendingNavigation(function () { return goBackTarget; });
            setShowNavDialog(true);
        }
        else {
            goBackTarget();
        }
    };
    useEffect(function () {
        var handleBeforeUnload = function (e) {
            if (isAccordionEditing) {
                e.preventDefault();
                e.returnValue = '';
                return '';
            }
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return function () { return window.removeEventListener('beforeunload', handleBeforeUnload); };
    }, [isAccordionEditing]);
    var hasAccess = function (permissionKey) {
        var perm = rolePermissions.find(function (p) { return p.PermissionKey === permissionKey; });
        if (!perm)
            return false;
        return perm.View === 1 || perm.Add === 1 || perm.Update === 1 || perm.Delete === 1;
    };
    var getUpdatePermission = function (permissionKey) {
        var perm = rolePermissions.find(function (p) { return p.PermissionKey === permissionKey; });
        return perm ? perm.Update === 1 : false;
    };
    var currentContractStatus = useMemo(function () {
        var _a, _b, _c, _d, _e;
        var statusOId = (_a = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _a === void 0 ? void 0 : _a.StatusOId;
        var matchedStatus = (_b = appResp === null || appResp === void 0 ? void 0 : appResp.ContractStatusList) === null || _b === void 0 ? void 0 : _b.find(function (item) { return item.OId == statusOId; });
        return (_e = (_d = (_c = matchedStatus === null || matchedStatus === void 0 ? void 0 : matchedStatus.Status) !== null && _c !== void 0 ? _c : matchedStatus === null || matchedStatus === void 0 ? void 0 : matchedStatus.status) !== null && _d !== void 0 ? _d : navigationStatus) !== null && _e !== void 0 ? _e : null;
    }, [mainResp, appResp, navigationStatus]);
    var currentStatusGroup = useMemo(function () {
        var _a, _b;
        var statusOId = (_a = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _a === void 0 ? void 0 : _a.StatusOId;
        if (statusOId === undefined || statusOId === null)
            return null;
        var matchedOption = statusGroupOptions.find(function (option) { return String(option.value) === String(statusOId); });
        return (_b = matchedOption === null || matchedOption === void 0 ? void 0 : matchedOption.statusGroup) !== null && _b !== void 0 ? _b : null;
    }, [mainResp, statusGroupOptions]);
    var isInsuranceEditableStatus = ['Approved', 'Documents'].includes(String(currentStatusGroup || normalizeStatus(currentContractStatus)));
    var isInsuranceBooked = !isInsuranceEditableStatus && "".concat(currentContractStatus !== null && currentContractStatus !== void 0 ? currentContractStatus : '').toLowerCase().includes('booked');
    var menuItems = [
        {
            label: 'AI Document Review',
            permissionKey: '',
            content: isMainInfoLoading || (awaitsPostDocsCheck && isAppDocumentsLoading) || (overviewWillShow && (isAiReviewLoading || lazyStatus.asset !== 'done'))
                ? React.createElement(AiReviewLoader, { variant: awaitsPostDocsCheck ? 'post' : 'pre' })
                : showPostDocsReview
                    ? React.createElement(BacklogPostDocsAI, { appResp: appResp, mainResp: mainResp, roleType: roleType, UDFsData: mainResp === null || mainResp === void 0 ? void 0 : mainResp.UDFsData, aiReviewData: aiReviewData, creditReport: creditReportItems, assetResp: assetResp, isDocumentPreviewOpen: Boolean(selectedDocumentPreview), TxAspireOId: id, documents: appDocuments, onDocumentOpen: handleDocumentOpen, onRefreshDocuments: getAppDocuments, contractAspireId: (_v = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _v === void 0 ? void 0 : _v.ContractAspireId, canDecide: isCurrentlyDocsBack, statusReasons: (_w = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _w === void 0 ? void 0 : _w.StatusReasons, onAcceptReview: function () { return updateContractStatus('59 - Docs in SS Review'); }, onDocsBackMissingInfo: function (statusReason) { return updateContractStatus('56 - Docs Back Missing Info', statusReason); } })
                    : React.createElement(BacklogAppOverview, { appResp: appResp, mainResp: mainResp, roleType: roleType, UDFsData: mainResp === null || mainResp === void 0 ? void 0 : mainResp.UDFsData, aiReviewData: aiReviewData, creditReport: creditReportItems, assetResp: assetResp, isDocumentPreviewOpen: Boolean(selectedDocumentPreview) }),
        },
        {
            label: 'Main',
            permissionKey: 'APPLICATION_MANAGMENT:BACKLOG_QUEUE:APP_MAIN',
            content: (React.createElement(Box, { key: "main-details" },
                React.createElement(MainDetails, { appResp: appResp, mainResp: mainResp, appMetaData: appMetaData, roleType: roleType, hasEditAccess: getUpdatePermission('APPLICATION_MANAGMENT:BACKLOG_QUEUE:APP_MAIN'), onDataRefresh: refreshAllData, onEditModeChange: setIsAccordionEditing, isLoan: isLoan, isDocumentPreviewOpen: Boolean(selectedDocumentPreview) })))
        },
        {
            label: 'Financing & Adjustments',
            permissionKey: 'APPLICATION_MANAGMENT:BACKLOG_QUEUE:APP_FINANCING_ADJUSTMENTS',
            content: (React.createElement(Box, null,
                React.createElement(FinancingAdjustments, { assetResp: assetResp, roleType: roleType, hasEditAccess: getUpdatePermission('APPLICATION_MANAGMENT:BACKLOG_QUEUE:APP_FINANCING_ADJUSTMENTS'), onDataRefresh: refreshAllData })))
        },
        {
            label: 'Billing & Payment Schedule',
            permissionKey: 'APPLICATION_MANAGMENT:BACKLOG_QUEUE:APP_BILLING_PAYMENT',
            content: (React.createElement(Box, null,
                React.createElement(PaymentSchedule, { isLoan: isLoan, appMetaData: appMetaData, mainResp: mainResp, assetResp: assetResp, roleType: roleType, hasEditAccess: getUpdatePermission('APPLICATION_MANAGMENT:BACKLOG_QUEUE:APP_BILLING_PAYMENT'), onDataRefresh: refreshAllData, onEditModeChange: setIsAccordionEditing })))
        },
        {
            label: 'EFT Assignment',
            permissionKey: 'APPLICATION_MANAGMENT:BACKLOG_QUEUE:APP_EFT_ASSIGNMENT',
            content: (React.createElement(Box, null,
                React.createElement(EFTAssignment, { TxAspireOId: id, appMetaData: appMetaData, roleType: roleType, hasEditAccess: getUpdatePermission('APPLICATION_MANAGMENT:BACKLOG_QUEUE:APP_EFT_ASSIGNMENT'), onDataRefresh: refreshAllData, onEditModeChange: setIsAccordionEditing })))
        },
        {
            label: 'UDFs (User Defined Fields)',
            permissionKey: 'APPLICATION_MANAGMENT:BACKLOG_QUEUE:APP_UDFS',
            content: (React.createElement(Box, null,
                React.createElement(UserDefinedFields, { mainResp: mainResp, roleType: roleType, hasEditAccess: getUpdatePermission('APPLICATION_MANAGMENT:BACKLOG_QUEUE:APP_UDFS'), onDataRefresh: refreshAllData, onEditModeChange: setIsAccordionEditing })))
        },
        {
            label: 'Documents Management',
            permissionKey: 'APPLICATION_MANAGMENT:BACKLOG_QUEUE:APP_DOCUMENT_MGMT',
            content: (React.createElement(Box, null, id && React.createElement(DocumentsManagement, { TxAspireOId: id, roleType: roleType, hasEditAccess: getUpdatePermission('APPLICATION_MANAGMENT:BACKLOG_QUEUE:APP_DOCUMENT_MGMT'), onDataRefresh: refreshAllData })))
        },
        {
            label: isLoan ? 'Collateral (Assets)' : 'Equipment (Assets)',
            permissionKey: 'APPLICATION_MANAGMENT:BACKLOG_QUEUE:APP_EQUIPMENT',
            content: (React.createElement(Box, null, isLoan ? (React.createElement(CollateralAssets, { assetResp: assetResp, appMetaData: appMetaData, mainResp: mainResp, roleType: roleType, hasEditAccess: getUpdatePermission('APPLICATION_MANAGMENT:BACKLOG_QUEUE:APP_EQUIPMENT'), onDataRefresh: refreshAllData, onEditModeChange: setIsAccordionEditing })) : (React.createElement(EquipmentAssets, { assetResp: assetResp, appMetaData: appMetaData, mainResp: mainResp, roleType: roleType, hasEditAccess: getUpdatePermission('APPLICATION_MANAGMENT:BACKLOG_QUEUE:APP_EQUIPMENT'), onDataRefresh: refreshAllData, onEditModeChange: setIsAccordionEditing }))))
        },
        {
            label: 'Schedule Billables',
            permissionKey: 'APPLICATION_MANAGMENT:BACKLOG_QUEUE:APP_SCHEDULE_BILLABLES',
            content: (React.createElement(Box, null,
                React.createElement(ScheduleBillables, { assetResp: assetResp, roleType: roleType, hasEditAccess: getUpdatePermission('APPLICATION_MANAGMENT:BACKLOG_QUEUE:APP_SCHEDULE_BILLABLES'), onDataRefresh: refreshAllData })))
        },
        {
            label: 'Accounts Payable',
            permissionKey: 'APPLICATION_MANAGMENT:BACKLOG_QUEUE:APP_ACCOUNTS_PAYABLE',
            content: (React.createElement(Box, null,
                React.createElement(AccountsPayable, { TxAspireOId: id, roleType: roleType, hasEditAccess: getUpdatePermission('APPLICATION_MANAGMENT:BACKLOG_QUEUE:APP_ACCOUNTS_PAYABLE'), onDataRefresh: refreshAllData, onEditModeChange: setIsAccordionEditing })))
        },
        {
            label: 'Liens',
            permissionKey: 'APPLICATION_MANAGMENT:BACKLOG_QUEUE:APP_LIENS',
            content: (React.createElement(Box, null,
                React.createElement(Liens, { TxAspireOId: id, roleType: roleType, hasEditAccess: getUpdatePermission('APPLICATION_MANAGMENT:BACKLOG_QUEUE:APP_LIENS'), onDataRefresh: refreshAllData, onEditModeChange: setIsAccordionEditing })))
        },
        {
            label: 'Insurance Management',
            permissionKey: 'APPLICATION_MANAGMENT:BACKLOG_QUEUE:APP_INSURANCE_MGMT',
            content: (React.createElement(Box, null,
                React.createElement(InsuranceManagement, { TxAspireOId: id, roleType: roleType, hasEditAccess: (isInsuranceEditableStatus || isInsuranceBooked) && getUpdatePermission('APPLICATION_MANAGMENT:BACKLOG_QUEUE:APP_INSURANCE_MGMT'), editOnlyWithoutConsent: isInsuranceBooked, isBooked: isInsuranceBooked, mainResp: mainResp, assetResp: assetResp, onLoadAssets: getAssetMngmtDetails, onDataRefresh: refreshAllData, onSilentRefresh: function () { return getApplicationMainDetails(true); } })))
        },
        {
            label: 'Reports',
            permissionKey: 'APPLICATION_MANAGMENT:BACKLOG_QUEUE:APP_REPORTS',
            content: (React.createElement(Box, null,
                React.createElement(Reports, { TxAspireOId: id, creditReportItems: creditReportItems, onCreditReportOpen: handleCreditReportOpen })))
        }
    ];
    var visibleMenuItems = menuItems.filter(function (item) { return !item.permissionKey || hasAccess(item.permissionKey); });
    var customerName = (primaryCustomer === null || primaryCustomer === void 0 ? void 0 : primaryCustomer.FirstName)
        ? "".concat(primaryCustomer.FirstName, " ").concat(primaryCustomer.MiddleName || '', " ").concat(primaryCustomer.LastName).trim()
        : (_x = primaryCustomer === null || primaryCustomer === void 0 ? void 0 : primaryCustomer.BusinessName) !== null && _x !== void 0 ? _x : '';
    var statusSteps = useMemo(function () { return buildStatusSteps(currentContractStatus, currentStatusGroup); }, [currentContractStatus, currentStatusGroup]);
    var metrics = [
        { value: (_z = (_y = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _y === void 0 ? void 0 : _y.Rate) !== null && _z !== void 0 ? _z : '--', label: 'APR' },
        { value: (_1 = (_0 = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _0 === void 0 ? void 0 : _0.Term) !== null && _1 !== void 0 ? _1 : '--', label: 'Months' },
        { value: ((_2 = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _2 === void 0 ? void 0 : _2.AmountFinanced) ? "".concat(Number(mainResp.ContractData.AmountFinanced).toLocaleString()) : '--', label: '$', suffix: '' },
    ];
    var panelTabLabelMap = {
        'APPLICATION_MANAGMENT:BACKLOG_QUEUE:APP_MAIN': 'Main',
        'APPLICATION_MANAGMENT:BACKLOG_QUEUE:APP_FINANCING_ADJUSTMENTS': 'Finance',
        'APPLICATION_MANAGMENT:BACKLOG_QUEUE:APP_BILLING_PAYMENT': 'Billing',
        'APPLICATION_MANAGMENT:BACKLOG_QUEUE:APP_EFT_ASSIGNMENT': 'EFT',
        'APPLICATION_MANAGMENT:BACKLOG_QUEUE:APP_UDFS': 'UDF\'s',
        'APPLICATION_MANAGMENT:BACKLOG_QUEUE:APP_DOCUMENT_MGMT': 'Documents',
        'APPLICATION_MANAGMENT:BACKLOG_QUEUE:APP_EQUIPMENT': 'Equipments',
        'APPLICATION_MANAGMENT:BACKLOG_QUEUE:APP_SCHEDULE_BILLABLES': 'Schedule',
        'APPLICATION_MANAGMENT:BACKLOG_QUEUE:APP_ACCOUNTS_PAYABLE': 'Accounts payable',
        'APPLICATION_MANAGMENT:BACKLOG_QUEUE:APP_LIENS': 'Liens',
        'APPLICATION_MANAGMENT:BACKLOG_QUEUE:APP_INSURANCE_MGMT': 'Insurance',
        'APPLICATION_MANAGMENT:BACKLOG_QUEUE:APP_REPORTS': 'Reports',
    };
    var isLazyDataReady = function (item) { var _a; return ((_a = TAB_LAZY_DATA[item.permissionKey]) !== null && _a !== void 0 ? _a : []).every(function (dataset) { return lazyStatus[dataset] === 'done'; }); };
    var panelTabs = visibleMenuItems.map(function (item) { return ({
        label: panelTabLabelMap[item.permissionKey] || item.label,
        content: isLazyDataReady(item)
            ? item.content
            : (React.createElement(Box, { display: "flex", alignItems: "center", justifyContent: "center", sx: { minHeight: 240 } },
                React.createElement(CircularProgress, { size: 32 }))),
    }); });
    var activeTabItem = visibleMenuItems[selectedTab];
    var activeTabNeeds = __spreadArray(__spreadArray([], ((_4 = TAB_LAZY_DATA[(_3 = activeTabItem === null || activeTabItem === void 0 ? void 0 : activeTabItem.permissionKey) !== null && _3 !== void 0 ? _3 : '']) !== null && _4 !== void 0 ? _4 : []), true), ((activeTabItem === null || activeTabItem === void 0 ? void 0 : activeTabItem.label) === 'AI Document Review' && overviewWillShow ? ['asset'] : []), true).join(',');
    React.useEffect(function () {
        if (!id || !activeTabNeeds)
            return;
        activeTabNeeds.split(',').forEach(ensureLazyDataset);
    }, [id, activeTabNeeds]);
    React.useEffect(function () {
        if (!panelTabs.length)
            return;
        if (selectedTab > panelTabs.length - 1) {
            setSelectedTab(0);
        }
    }, [panelTabs.length, selectedTab]);
    var handleDetailsScrollCapture = function (event) {
        var target = event.target;
        var currentTarget = event.currentTarget;
        var containerCanScroll = currentTarget.scrollHeight > currentTarget.clientHeight;
        var targetCanScroll = Boolean(target && target.scrollHeight > target.clientHeight);
        if (!containerCanScroll && !targetCanScroll) {
            return;
        }
    };
    return (React.createElement(Box, { ref: pageRootRef, sx: {
            display: 'flex',
            flexDirection: 'column',
            height: "calc(100vh - ".concat(pageTopOffset, "px)"),
            minHeight: 0,
            overflow: 'hidden',
        } },
        mainResp && (React.createElement(Box, { sx: {
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                gap: 1,
                px: 2,
                py: 1,
                flexShrink: 0,
                backgroundColor: baseColors.fullWhite,
                borderBottom: "1px solid ".concat(baseColors.greyPreset[40]),
            } }, headerChips.map(function (chip) { return (React.createElement(Box, { key: chip.label, sx: {
                display: 'inline-flex',
                alignItems: 'baseline',
                gap: 0.4,
                px: 1,
                py: 0.4,
                backgroundColor: baseColors.greyPreset[55],
                borderRadius: 1,
                border: "1px solid ".concat(baseColors.greyPreset[40]),
                maxWidth: '100%',
            } },
            React.createElement(Typography, { sx: { fontSize: 11, fontWeight: 500, color: baseColors.greyPreset[10], whiteSpace: 'nowrap' } },
                chip.label,
                ":"),
            React.createElement(Typography, { sx: { fontSize: 11, fontWeight: 700, color: baseColors.fullBlack }, noWrap: true }, chip.value))); }))),
        React.createElement(Box, { sx: { flex: 1, minHeight: 0 } },
            React.createElement(ApplicationDetailsPanel, { applicationId: id ? "AUX - ".concat(id) : '', onScrollCapture: handleDetailsScrollCapture, customerName: customerName, customerCode: ((_5 = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _5 === void 0 ? void 0 : _5.ContractAspireId) ? "AUX - ".concat(mainResp.ContractData.ContractAspireId) : undefined, statusSteps: statusSteps, metrics: metrics, tabs: panelTabs, isRightPanelCompact: isRightPanelCompact, fillParentHeight: true, documentPreviewPanel: selectedDocumentPreview ? (React.createElement(DocumentPreviewPanel, { title: selectedDocumentPreview.title, loading: selectedDocumentPreview.loading, previewType: selectedDocumentPreview.previewType, fileUrl: selectedDocumentPreview.fileUrl, previewHtml: selectedDocumentPreview.previewHtml, binaryData: selectedDocumentPreview.binaryData, jsonData: selectedDocumentPreview.jsonData, attachments: selectedDocumentPreview.attachments, onClose: handleDocumentPreviewClose })) : null, rightPanel: (React.createElement(RightSection, { roleType: roleType, appResp: appResp, mainResp: mainResp, tabs: panelTabs, documents: appDocuments, isDocumentPreviewOpen: Boolean(selectedDocumentPreview), selectedDocumentId: selectedDocumentPreview === null || selectedDocumentPreview === void 0 ? void 0 : selectedDocumentPreview.documentIdentifier, activePreviewSection: selectedDocumentPreview === null || selectedDocumentPreview === void 0 ? void 0 : selectedDocumentPreview.source, onDocumentOpen: handleDocumentOpen, onCreditReportOpen: handleCreditReportOpen, creditReportItems: creditReportItems, handleDocumentPreviewClose: handleDocumentPreviewClose, onCompactModeChange: setIsRightPanelCompact, fundingLogRow: navigationState.fundingLogRow })), activeIndex: selectedTab, onBack: handleGoBack, onTabChange: handleTabChange })),
        React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.UNSAVED_DATA_WARNING, titleText: "Unsaved Changes", message: "You have unsaved changes. Are you sure you want to leave without saving?", acceptBtnText: "Leave", denyBtnText: "Stay", open: showNavDialog, acceptCallBack: function () {
                setShowNavDialog(false);
                setIsAccordionEditing(false);
                if (pendingNavigation) {
                    pendingNavigation();
                    setPendingNavigation(null);
                }
            }, denyCallBack: function () {
                setShowNavDialog(false);
                setPendingNavigation(null);
            }, cancelCallBack: function () {
                setShowNavDialog(false);
                setPendingNavigation(null);
            } })));
};
export default BacklogAppDetails;
